import { LoadingButtonProps } from '@mui/lab/LoadingButton';
import { StyledButton } from './PargodaRoundButton.styles';

interface Props extends LoadingButtonProps {
    buttonColor?: string;
    textColor?: string;
}

export const PargodaRoundButton = (props: Props) => {
    return <StyledButton data-testid={'p-btn-container'} {...props} />;
};

export default PargodaRoundButton;
